import { Banner, KIND } from "baseui/banner";

const ErrorComponent = ({ error }) => {
  return (
    <Banner title="Authentification error" kind={KIND.negative}>
      An authentification error occurred: {error.errorCode}
    </Banner>
  )
}

export default ErrorComponent;


